import React from "react";

const base = {
	width: 18,
	height: 18,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	stroke: "currentColor",
	strokeWidth: 1.8,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	"aria-hidden": true,
	focusable: "false",
};

export function IconPatient(props) {
	return (
		<svg {...base} {...props}>
			<circle cx="12" cy="8" r="3.2" />
			<path d="M6.5 20c.7-4 3.2-6 5.5-6s4.8 2 5.5 6" />
			<path d="M18.2 8.5h2.8" />
			<path d="M19.6 7.1v2.8" />
		</svg>
	);
}

export function IconBiomarker(props) {
	return (
		<svg {...base} {...props}>
			<path d="M8 4c4 0 8 4 8 8s-4 8-8 8" />
			<path d="M16 4c-4 0-8 4-8 8s4 8 8 8" />
			<path d="M9.5 8h5" />
			<path d="M9.5 12h5" />
			<path d="M9.5 16h5" />
		</svg>
	);
}

const IconTreatment = (props) => (
	<svg {...base} {...props}>
		<path
			d="M7.5 6.5a4 4 0 0 1 5.7 0l4.8 4.8a4 4 0 0 1 0 5.7 4 4 0 0 1-5.7 0l-4.8-4.8a4 4 0 0 1 0-5.7Z"
		/>
		<path
			d="M7.5 6.5a4 4 0 0 1 5.7 0l2.6 2.6-5.7 5.7-2.6-2.6a4 4 0 0 1 0-5.7Z"
			fill="currentColor"
			stroke="none"
			opacity="0.85"
		/>
		<path d="M9.5 14.5 14.5 9.5" />
	</svg>
);



export function IconResponse(props) {
	return (
		<svg {...base} {...props}>
			<path d="M4 19V5" />
			<path d="M4 19h16" />
			<path d="M6.5 15.5l4-4 3 3 5-6" />
			<path d="M18.5 8.5v2.5H16" />
		</svg>
	);
}

export function IconManuscript(props) {
	return (
		<svg {...base} {...props}>
			<path d="M7 4h8l2 2v14H7z" />
			<path d="M15 4v3h3" />
			<path d="M9 10h6" />
			<path d="M9 13h6" />
			<path d="M9 16h4" />
		</svg>
	);
}

export function IconDefault(props) {
	return (
		<svg {...base} {...props}>
			<circle cx="12" cy="12" r="7.5" />
			<path d="M12 8.2v4.2" />
			<path d="M12 16.2h.01" />
		</svg>
	);
}

const ICON_BY_CATEGORY = {
	"patient-characteristics": IconPatient,
	"biomarker-characteristics": IconBiomarker,
	"treatment-characteristics": IconTreatment,
	"response-characteristics": IconResponse,
	"manuscript-characteristics": IconManuscript,
	default: IconDefault, // fallback
};

export function CategoryIcon({ category, ...props }) {
	const Icon = ICON_BY_CATEGORY[category] || ICON_BY_CATEGORY.default;
	return <Icon {...props}/>;
}
